import { render, staticRenderFns } from "./SolicitudTransferenciaRecursos.vue?vue&type=template&id=4c12dc10&scoped=true"
import script from "./SolicitudTransferenciaRecursos.vue?vue&type=script&lang=js"
export * from "./SolicitudTransferenciaRecursos.vue?vue&type=script&lang=js"
import style0 from "./SolicitudTransferenciaRecursos.vue?vue&type=style&index=0&id=4c12dc10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c12dc10",
  null
  
)

export default component.exports